import React from 'react';
import { translate } from '../../Helper';
import Tooltip from './Tooltip';

const CustomizedPill = () => {
    return (
        <span className="ecre-ml-2 ecre-px-2 ecre-py-1 ecre-bg-blue-100 ecre-text-blue-800 ecre-text-xs ecre-rounded-full ecre-inline-flex ecre-items-center ecre-gap-1 ecre-cursor-help">
            {translate('customized')}
            <Tooltip content={translate('custom_settings_tooltip')} iconColor="#2563eb" />
        </span>
    );
};

export default CustomizedPill;
